var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRadioSelectedR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  rx: 10,
  fill: "#28027A"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.36646 12.1L14.0165 6.45C14.1498 6.31667 14.3054 6.25 14.4831 6.25C14.6609 6.25 14.8165 6.31667 14.9498 6.45C15.0831 6.58333 15.1498 6.74178 15.1498 6.92533C15.1498 7.10889 15.0831 7.26711 14.9498 7.4L8.83313 13.5333C8.69979 13.6667 8.54424 13.7333 8.36646 13.7333C8.18868 13.7333 8.03313 13.6667 7.89979 13.5333L5.03313 10.6667C4.89979 10.5333 4.83579 10.3751 4.84113 10.192C4.84646 10.0089 4.91602 9.85044 5.04979 9.71667C5.18357 9.58289 5.34202 9.51622 5.52513 9.51667C5.70824 9.51711 5.86646 9.58378 5.99979 9.71667L8.36646 12.1Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRadioSelectedR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/radio-selected-r.5bdd62b10e0b0389b7511ef4c5cf7de8.svg";